import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=5d44c15d&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=ts"
export * from "./OrderDetails.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=5d44c15d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d44c15d",
  null
  
)

export default component.exports